import { useEffect } from 'react'

const BASE_URL = 'https://halalwealth.co'

function upsertMeta(name, content) {
  if (!content) return

  let tag = document.querySelector(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function upsertCanonical(pathname) {
  let link = document.querySelector('link[rel="canonical"]')
  if (!link) {
    link = document.createElement('link')
    link.setAttribute('rel', 'canonical')
    document.head.appendChild(link)
  }
  link.setAttribute('href', `${BASE_URL}${pathname}`)
}

function Seo({ title, description, pathname = '/' }) {
  useEffect(() => {
    if (title) {
      document.title = title
    }

    upsertMeta('description', description)
    upsertCanonical(pathname)
  }, [title, description, pathname])

  return null
}

export default Seo
